import { ErrorsUtil, MessageBoxComponent, WaitComponent } from '@sircon/sircon-ui-framework';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProducerPortalHttpService } from 'src/providers/producer-portal-http.service';
import { UserContextService } from 'src/services/user-context.service';
import { NgIf } from '@angular/common';

/**
 * This component is intended to be a landing/transition page to handle redirecting a user into another Sircon application.
 */
@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.less'],
    imports: [MessageBoxComponent, NgIf, WaitComponent]
})
export class RedirectComponent implements OnInit {
    loading: boolean;
    errors;
    product;
    userContext;
    redirectUrl;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private producerPortalHttpService: ProducerPortalHttpService,
                private userContextService: UserContextService
    ) {
    }

    ngOnInit() {
        this.loading = true;
        this.product = this.route.snapshot.queryParams.product;
        this.errors = ErrorsUtil.create();
        this.userContext = this.userContextService.userContext;

        this.redirectToApplication();
    }

    redirectToApplication() {
        if (this.product && this.product === 'producerPortal') {
            this.producerPortalHttpService.loginToProducerPortal(this.userContext.user.id)
                .toPromise()
                .then((response: any) => {
                    this.redirectUrl = response.redirectUrl;
                    this.setWindowLocation(this.redirectUrl);
                })
                .catch((response) => {
                    this.errors = ErrorsUtil.mapResponse(response);
                })
                .finally(() => {
                    this.loading = false;
                });
        } else {
            this.router.navigate(['/error']);
        }
    }

    setWindowLocation(href) {
        window.location.href = href;
    }

}
